import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

export class AppliSetting {
    nPointAuthService: string;
    nPointDeclarations: string;
    urlPasswordReset: string;
    urlVideoDashboard: string;
    captchaSiteKey: string;
}

@Injectable()
export class AppConfig {
    private _ConfigPath: string = './assets/config';
    private config: AppliSetting = null;
    private env: Object = null;
    private setting: any = null;

    constructor(private http: HttpClient) {}
    /**
     * Use to get the data found in the second file (config file)
     */
    public getConfig(): AppliSetting {
        return this.config;
    }

    /**
     * Use to get the data found in the first file (env file)
     */
    public getEnv(key: any) {
        return this.env[key];
    }

    public getSetting() {
        return this.setting;
    }


    public setSetting(s) {
        this.setting = s;
    }

    /**
     * This method:
     *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
     *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
     */
    public load() {
        return new Promise((resolve, reject) => {
            this.http.get(this._ConfigPath + '/env.json').catch((error: any): any => {
                resolve(true);
                return Observable.throw(error.json().error || 'Server error');
            }).subscribe((envResponse: any) => {
                this.env = envResponse.env;
                const request: any = this.http.get(this._ConfigPath + '/config.' + this.env + '.json');

                if (request) {
                    request
                        .catch((error: any) => {
                            console.error('Error reading ' + this.env + ' configuration file');
                            resolve(error);
                            return Observable.throw(error.json().error || 'Server error');
                        })
                        .subscribe((responseData: any) => {
                            this.config = responseData;
                           resolve(true);
                        });
                } else {
                    console.error('Env config file "env.json" is not valid');
                    resolve(true);
                }
            });

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts